const random = () => {
  return Math.floor(Math.random() * 1000000) + 1
}

// Set up function to get signature required for Baron API requests
const getSignature = async () => {
  try {
    const response = await fetch(`https://pbsweather.org/shared/server/signature.php?id=${random()}`)
    const signature = await response.text()
    return signature
  } catch(error) {
    console.log(error, 'getSignature error')
  }
}

// Set up function to get product instances (these are timestamps)
// for the tiles we are requesting from the server
const getProductInstances = async (product = baronTiles.radar.composite_250m.code) => {
  try {
    const response = await fetch(`https://pbsweather.org/shared/server/tiles.php?id=${random()}&product=${product}&product_config=Standard-Mercator`)
    const instances = await response.text()
    return instances

  } catch(error) {
    console.log(error, 'getProductInstances error')
  }
}

// Make server call to get lightning data
const getLightning = async () => {
  try {
    const response = await fetch(`https://pbsweather.org/shared/server/lightning.php?id=${random()}`)
    const data = await response.json()
    let strikes = data.lightning.data
    return strikes.map(strike => strike.coordinates)
  } catch(error) {
    console.log(error, 'getLightning error')
  }
}

// Get METAR Data
const getMetar = (lat, lon) => {
  return fetch(`https://pbsweather.org/shared/server/metar_nearest.php?lat=${lat}&lon=${lon}`)
    .then(response => response.json())
    .catch(error => 'console.log(error)')
}

// Get NWS Alert Data
/* type is defined as the following: 
  "all" -- all county-based NWS watches and warnings; corresponds with alert-all tile product
  "all-poly" -- all county-based and polygon-based NWS watches and warnings; corresponds with alert-all-poly tile product
  "poly" -- all polygon-based NWS watches and warnings; corresponds with alert-poly tile product
  "marine" -- all offshore marine alerts; corresponds with alert-marine tile product
*/
const getAlerts = (type = 'all-poly', lat, lon) => {
  return fetch(`https://pbsweather.org/shared/server/alerts.php?id=${random()}&type=${type}&lat=${lat}&lon=${lon}`)
  .then(response => response.json())
  .catch(error => console.log(error))
}

// Handle cases where there may be no data (i.e. no "instances" returned from the server)
/* For example, 404 (Not Found) will be returned from the server if there are no tropical cyclones in the
   Atlantic or Eastern Pacific Basin. Similarly, there will be no tropical cyclone spaghetti model plots
   if there are no tropical cyclones. 
*/
const noDataHandler = (product) => {
  switch (product) {
    case baronTiles.tropical.nhc.code:
      return alert('There are no Tropical Storms or Hurricanes at this time')
    case baronTiles.tropical.spaghetti.code:
      return alert('There are no Tropical Storms or Hurricanes at this time')
    default:
      return alert('No data has been found')
  }
}

export { getSignature, getProductInstances, getLightning, getMetar, getAlerts, noDataHandler }